'use client';

import type { BestSellingProps } from './data';

import {
  Box,
  Container,
  Image,
  Link,
  ProductCard,
  SectionHeading,
  SimpleGrid,
  Stack,
} from '@/components';
import { useTranslation } from '@/hooks';
import { routes } from '@/statics';

const BestSelling: React.FC<BestSellingProps> = ({
  products,
  bannerCategory,
}) => {
  const { t } = useTranslation('pages.home');
  return (
    <Container>
      <Stack w="full" py={{ base: '44px', md: '24px' }} gap={5}>
        <Stack
          w="full"
          gap={2}
          flexDir={{ base: 'column', md: 'row' }}
          alignItems={{ base: 'center', md: 'start' }}
        >
          <Stack gap="30px">
            <SectionHeading
              title={t('best-selling')}
              subtitle={t('selectProduct')}
            />
          </Stack>
        </Stack>
        <SimpleGrid flexDir="row" columns={{ base: 2, md: 3, xl: 6 }} gap={4}>
          <Box
            width="100%"
            aspectRatio={523 / 960}
            position="relative"
            href={routes.category.href(bannerCategory?.code || 0)}
            as={Link}
            target="_blank"
            sx={{
              '& img': {
                objectFit: 'cover',
                borderRadius: 'xs',
              },
            }}
          >
            <Image
              src={bannerCategory?.banner_image || ''}
              alt={'mostViewed'}
              fill
              sizes="(min-width: 90em) 224px, (min-width: 80em) calc((100vw - 100px) / 6), (min-width: 48em) calc((100vw - 52px) / 3), calc((100vw - 36px) / 2)"
            />
          </Box>
          {products.map((product) => (
            <ProductCard
              cardData={product}
              key={product.code}
              link={routes.product.href(product.code)}
            />
          ))}
        </SimpleGrid>
      </Stack>
    </Container>
  );
};
export default BestSelling;
